const LINKS = {
  X: 'https://x.com/mtt_sports',
  DISCORD: 'https://discord.gg/znxxushGfJ',
  TELEGRAM: 'https://t.me/+cdbWvezq6PljODU1',
  OFFICIAL: 'https://mtt.xyz/',
  WHITE_PAPER: 'https://mtt-network.gitbook.io/mtt-network-1',
  GITHUB: 'https://github.com/orgs/mtt-labs/repositories',
  EXPLORER: 'https://explorer.mtt.network',
  AML: 'https://cdn-web.mtt.xyz/static/AML.pdf',
  SelfExclusion: 'https://cdn-web.mtt.xyz/static/Self.Exclusion.Policy.pdf',
  Commitment:
    'https://cdn-web.mtt.xyz/static/Commitment.to.Preventing.Underage.Gambling.pdf',
  Kyc: 'https://cdn-web.mtt.xyz/static/KYC.Policy.Anjouan.pdf',
  Tnc: 'https://cdn-web.mtt.xyz/static/Terms.and.Conditions.Anjouan.pdf',
  Responsible: 'https://cdn-web.mtt.xyz/static/Responsible.Gaming.Anjouan.pdf',
  Tou: 'https://static-s3.mtt.xyz/chain-website/Terms%20of%20use%2024-11-26-01.pdf',
  Privacy:
    'https://static-s3.mtt.xyz/app-sports/Privacy%20&%20Cookie%20Policy%2024-11-26.pdf',
  Ubuntu: 'https://github.com/mtt-labs/mtt-chain',
  ValidatorProtocol: 'https://docs.mtt.network/',
  Yaakoswap: 'https://www.mtt.network/yaakoSwap',
};

export const BACKEND_HOST = 'https://cosmos-validator.mtt.network';
export const DEV_BACKEND_HOST = 'https://dev-cosmos-validator.mtt.network';

export const OFFICIAL_NODES = [
  'mttvaloper10wpwl4mqpgdgz8597kphgahx3a8degvgtnmw9f',
  'mttvaloper1k8kvrwjug3y4etx7yrsj04n9zfvuzgn32ptt5u',
  'mttvaloper1l8t92876df8zhlu47ytm28kugc03wy589l32s4',
  'mttvaloper1vckwcfuu8xvul9xyja4sw2junq3yfd4pu06c6p',
];

/** Hardcoded BTC stake shown on official nodes (is_offical). */
export const OFFICIAL_NODE_BTC_AMOUNT = 250;
// export const BACKEND_HOST = 'http://8.219.219.202:8086';

export default LINKS;
